import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { Menu, Input, Button, Select } from 'antd';

import AceEditor from 'react-ace';
import { toastSuccess, toastError } from '../../utils/toastr';

import 'brace/ext/searchbox';
import 'brace/ext/language_tools';
import 'brace/ext/emmet';

import 'brace/mode/javascript';
import 'brace/mode/html';
import 'brace/mode/json';
import 'brace/mode/css';
import 'brace/mode/php';
import 'brace/snippets/php';
import 'brace/ext/split';
import 'brace/theme/monokai';
import 'brace/theme/chrome';

import MainMenu from '../../components/mainMenu';

import requestAPI from '../../helpers/requestAPI';

import './editor.scss';

const FileEditor = ({ contentFromSelectedFile, selectedElements }) => {
	const [ fontSize, setFontSize ] = useState('12px');
	const [ mode, setMode ] = useState('javascript');
	const [ theme, setTheme ] = useState('chrome');
	const [ content, setContent ] = useState('');
	const [ fileName, setFileName ] = useState('');

	const { Option } = Select;

	const editorRef = useRef();
	const filename = selectedElements.selectedElements.length > 0 ? selectedElements.selectedElements[0].name : '';

	useEffect(
		() => {
			setFileName(filename);
			setContent(contentFromSelectedFile);
		},
		[ filename, contentFromSelectedFile ]
	);

	const onClickSaveChanges = (e) => {
		if (fileName === '') {
			toastError('Set file name');
			return false;
		}

		const data = new Blob([ content ], { type: 'text/plain' });

		const params = {
			routeParams: {
				route: 'file'
			},
			additionalQueryStringParams: {
				site_id: selectedElements.siteId,
				directory: selectedElements.directory,
				filename: fileName
			},
			method: 'post',
			data: data
		};

		requestAPI(params)
			.then((response) => {
				toastSuccess('File changed successfully');
			})
			.catch((error) => {
				toastError(error);
			});
	};

	return (
		<div className="editor-page">
			<MainMenu />

			<div className="editor">
				<Menu
					mode={'horizontal'}
					theme={'light'}
					selectable={false}
					style={{ display: 'flex', justifyContent: 'center' }}
				>
					<Menu.Item className="modified-item" key="fileName" style={{ display: 'flex', alignItems: 'center' }}>
						Set file name:
						<Input value={fileName} onChange={(e) => setFileName(e.target.value)} />
					</Menu.Item>
					<Menu.Item key="find" className="modified-item">
						<Button
							icon="search"
							type="primary"
							onClick={() => {
								editorRef.current.editor.execCommand('find');
							}}
							size="large"
						/>
					</Menu.Item>
					<Menu.Item key="undo" className="modified-item">
						<Button
							icon="undo"
							type="primary"
							onClick={() => {
								editorRef.current.editor.undo();
							}}
							size="large"
						/>
					</Menu.Item>
					<Menu.Item key="redo" className="modified-item">
						<Button
							icon="redo"
							type="primary"
							onClick={() => {
								editorRef.current.editor.redo();
							}}
							size="large"
						/>
					</Menu.Item>
					<Menu.Item key="save" className="modified-item">
						<Button icon="save" type="primary" onClick={onClickSaveChanges} size="large" />
					</Menu.Item>
					<Menu.Item key="size" className="modified-item">
						<label>Font-size: </label>
						<Select defaultValue="12" style={{ width: '70px' }} onChange={(value) => setFontSize(value + 'px')}>
							<Option value="10">10</Option>
							<Option value="12">12</Option>
							<Option value="14">14</Option>
							<Option value="16">16</Option>
							<Option value="18">18</Option>
							<Option value="20">20</Option>
							<Option value="22">22</Option>
						</Select>
					</Menu.Item>
					<Menu.Item key="mode" className="modified-item">
						<label>Mode: </label>
						<Select defaultValue="javascript" style={{ width: '130px' }} onChange={(value) => setMode(value)}>
							<Option value="javascript">JavaScript</Option>
							<Option value="html">HTML</Option>
							<Option value="json">JSON</Option>
							<Option value="css">CSS</Option>
							<Option value="php">PHP</Option>
						</Select>
					</Menu.Item>
					<Menu.Item key="theme" className="modified-item">
						<label>Theme: </label>
						<Select defaultValue="chrome" style={{ width: '100px' }} onChange={(value) => setTheme(value)}>
							<Option value="chrome">Light</Option>
							<Option value="monokai">Dark</Option>
						</Select>
					</Menu.Item>
				</Menu>

				<AceEditor
					ref={editorRef}
					setOptions={{
						enableBasicAutocompletion: true,
						enableLiveAutocompletion: true,
						tabSize: 2,
						enableEmmet: true
					}}
					mode={mode}
					theme={theme}
					onChange={(newValue) => setContent(newValue)}
					value={content}
					placeholder={'This file is empty, type something...'}
					name="code-block"
					editorProps={{ $blockScrolling: Infinity }}
					width="100%"
					height="calc(100vh - 48px - 46px)"
					fontSize={fontSize}
				/>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		contentFromSelectedFile: state.editor.fileContent,
		selectedElements: state.selectedElement
	};
};

export default connect(mapStateToProps)(FileEditor);
